/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { validateAuthFields } from '../../redux/validateAuthFields';
import { RegisterAction, RegisterActionTypes } from './actions';

export interface RegisterState {
  loading: boolean;
  error?: any;
  success?: boolean;
  registrationFields: {
    email?: string;
    password?: string;
    confirmPassword?: string;
    givenName?: string;
    familyName?: string;
    agreedToTerms?: boolean;
    phone?: string;
  };
}

export const initialRegisterState: RegisterState = {
  loading: false,
  registrationFields: {
    email: '',
    password: '',
    confirmPassword: '',
    givenName: '',
    familyName: '',
    agreedToTerms: false,
    phone: '',
  },
};

export default function registerReducer(state = initialRegisterState, action: RegisterAction): RegisterState {
  switch (action.type) {
    case RegisterActionTypes.REGISTER_REQUEST: {
      return update(state, {
        loading: { $set: true },
        success: { $set: false },
      });
    }

    case RegisterActionTypes.REGISTER_SUCCESS:
      return update(state, {
        loading: { $set: false },
        success: { $set: true },
      });

    case RegisterActionTypes.REGISTER_ERROR:
      return update(state, {
        error: { $set: action.error },
        loading: { $set: false },
        success: { $set: false },
      });

    case RegisterActionTypes.CLEAR_REGISTER_ERROR:
      return update(state, {
        $unset: ['error'],
      });

    case RegisterActionTypes.SET_REGISTRATION_FIELD:
      return validateAuthFields(state, { [action.field]: action.value }, 'registrationFields');

    default:
      return state;
  }
}
